import React from "react"

import {H2} from "@irati/ui/src/Typography/Heading"
import authentication from "@irati/auth"

import {GroupCelebration} from "@irati/types"

interface GroupCelebrationProps {
  groupCelebration: GroupCelebration
}
const GroupCelebrationTitle = ({groupCelebration}: GroupCelebrationProps) => {
  const {uuid: receiverUUID, firstName, lastName} = groupCelebration.receiver!
  const isReceiver = authentication.user().uuid === receiverUUID
  const receiverLabel = isReceiver ? firstName : `${firstName} ${lastName}`
  const title = `${groupCelebration.greeting?.label}, ${receiverLabel}`
  return <H2>{title}</H2>
}
export default GroupCelebrationTitle
